<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.stroke]="fillColor"
    d="m20.482 13.978-7.721 7.707c-.421.42-1.1.42-1.521 0l-7.722-7.707-.76-.76A5.96 5.96 0 0 1 1 8.987c0-1.531.584-3.066 1.757-4.233a6.007 6.007 0 0 1 8.482 0c.421.42 1.1.42 1.521 0a6.007 6.007 0 0 1 8.483 0A5.952 5.952 0 0 1 23 8.986a5.952 5.952 0 0 1-1.757 4.233l-.761.759-7.721 7.707c-.421.42-1.1.42-1.521 0l-7.722-7.707"
  />
</svg>
